<template>
  <div class="flex items-start justify-between">
    <div class="min-w-[250px] p-[12px] pt-0">
      <p class="mb-[4px]">
        {{ product.product_name || '-' }}
      </p>
      <slot />
    </div>
    <div
      class="w-[70px] flex-none p-[12px] pt-0"
      :class="quantityAlign === 'right' ? 'text-right' : 'text-left'"
    >
      x {{ product.quantity }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCardItem',
  props: {
    product: {
      type: Object,
      required: true,
    },
    quantityAlign: {
      type: String,
      required: false,
      default: 'left',
    },
  },
}
</script>
